// extracted by mini-css-extract-plugin
export default {"text-component__container":"styles_text-component__container__ZoCA5","dot":"styles_dot__VYQX6"};